// extracted by mini-css-extract-plugin
export var odd = "App-module--odd--2ZScx";
export var appName = "App-module--app-name--1zxGy";
export var appDesc = "App-module--app-desc--GvxrD";
export var even = "App-module--even--3IV4p";
export var appContainer = "App-module--app-container--kwmqB";
export var reverse = "App-module--reverse--yhLvC";
export var imageContainer = "App-module--image-container--18nmH";
export var infoContainer = "App-module--infoContainer--3NJNn";